import { useState } from 'react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator,
} from '@chatscope/chat-ui-kit-react';


const API_KEY = "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";
const systemMessage = {
  "role": "system",
  "content": "Explain things like you're a therapist advising a construction worker. Limit your responses to 100 words."
};


function Contact() {
  const [messages, setMessages] = useState([
    {
      message: "Hello, I'm MeowMeow, your personal assistant! Ask me anything. I'm here to help if you're experiencing any problems or if you just want someone to talk to.",
      sentTime: "just now",
      sender: "ChatGPT"
    }
  ]);
  const [isTyping, setIsTyping] = useState(false);


  const handleSend = async (message) => {
    const newMessage = {
      message,
      direction: 'outgoing',
      sender: "user"
    };


    const newMessages = [...messages, newMessage];


    setMessages(newMessages);


    setIsTyping(true);
    await processMessageToChatGPT(newMessages);
  };


  async function processMessageToChatGPT(chatMessages) {
    let apiMessages = chatMessages.map((messageObject) => {
      let role = "";
      if (messageObject.sender === "ChatGPT") {
        role = "assistant";
      } else {
        role = "user";
      }
      return { role: role, content: messageObject.message };
    });


    const apiRequestBody = {
      "model": "gpt-3.5-turbo",
      "messages": [
        systemMessage,
        ...apiMessages
      ]
    };


    await fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + API_KEY,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(apiRequestBody)
    })
    .then((data) => data.json())
    .then((data) => {
      console.log(data);
      setMessages([
        ...chatMessages,
        {
          message: data.choices[0].message.content,
          sender: "ChatGPT"
        }
      ]);
      setIsTyping(false);
    });
  }


  return (
    <div className="App">
      <style>
        {`
         
          .centered-container {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 80vh; /* Reduced height */
          }


          .chat-container {
            background-color: #c2f0c2;
            color: #333;
            max-width: 80%; /* Takes up 80% of the width */
            max-height: 200px; /* Reduced height */
            padding: 10px;
            border: 2px solid #007bff; /* Add a nice border */
            border-radius: 10px;
          }


          /* Increase text size */
          .message-text {
            font-size: 30px;
          }


          /* Other styles here */
          .message.outgoing {
            background-color: #007bff;
            color: #fff;
          }


          .message.incoming {
            background-color: #e0e0e0;
            color: #333;
          }


          .message-input {
            border: 1px solid #ccc;
            border-radius: 5px;
            background-color: #fff;
            color: #333;
          }


          .typing-indicator {
            color: #007bff;
          }
        `}
      </style>
      <div className="centered-container">
        <MainContainer>
          <ChatContainer>
            <MessageList scrollBehavior="smooth" typingIndicator={isTyping ? <TypingIndicator content="MeowMeow is typing" /> : null}>
              {messages.map((message, i) => {
                console.log(message);
                return <Message key={i} model={message} />;
              })}
            </MessageList>
            <MessageInput placeholder="Type message here" onSend={handleSend} />
          </ChatContainer>
        </MainContainer>
      </div>
    </div>
  );
}

export default Contact;
